import axios from 'axios';
// import router from '../router/index';

const instance = axios.create({
    baseURL: 'http://123.207.213.228:8082', // 设置基础URL
});

export default instance;